import React from "react";
import styles from "../pages/presenze/dashboardWF/wf.dashboard.module.css";
import {IconBan, IconCheck, IconHourglass, IconScale} from "@tabler/icons-react";

interface BadgeProps {
    wfStato: 'IN_ATTESA' | 'IN_VALUTAZIONE' | 'ACCETTATA' | 'RIFIUTATA',
    size?: number,
    accettataSize?: string
}

const WFIcons: React.FC<BadgeProps> = ({wfStato, size = 20}) => {
    return <>
        {wfStato === 'IN_ATTESA' && <IconHourglass size={size} className={styles.inAttesaColor}/>}
        {wfStato === 'IN_VALUTAZIONE' && <IconScale size={size} className={styles.inValutazioneColor}/>}
        {wfStato === 'RIFIUTATA' && <IconBan size={size} className={styles.respintaColor}/>}
        {wfStato === 'ACCETTATA' && <IconCheck className={`${styles.accettataColor}`} style={{width: size + 'px', height: size + 'px'}}/>}
    </>
}
export default WFIcons;


